import {
    Box,
    Container,
    Flex,
    Heading,
    HStack,
    IconButton,
    Skeleton,
    useDisclosure
} from '@chakra-ui/react';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { faCircleUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import { FC, ReactNode } from 'react';
import SelectUserModal from 'src/components/home/select-user-modal/SelectUserModal';
import { User } from 'src/models';
import { useLanguage } from 'src/utils/hooks/useLanguage';

type Props = {
    actionComponent?: ReactNode;
    backUrl?: string;
    onBackClick?: () => void;
    multiUser?: boolean;
    isReady?: boolean;
    title: string;
    currentUser?: User;
    users?: User[];
    setCurrentUserId?: (users: User[], userId?: string | undefined) => void;
    showUserPicker?: boolean;
};

const Topbar: FC<Props> = (props) => {
    const {
        actionComponent,
        isReady,
        backUrl,
        onBackClick,
        multiUser,
        title,
        currentUser,
        users,
        setCurrentUserId,
        showUserPicker
    } = props;
    const router = useRouter();
    const { language } = useLanguage();
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <Box bg="white" position="fixed" top={0} width="100%" zIndex="banner">
            <Box
                backgroundImage="/pattern2.png"
                backgroundPosition="right"
                backgroundRepeat="no-repeat">
                <Container maxW="container.sm" paddingY={4}>
                    <Flex justifyContent="space-between" width="100%">
                        <IconButton
                            aria-label="Back"
                            icon={<FontAwesomeIcon icon={faChevronLeft} />}
                            opacity={backUrl || onBackClick ? 1 : 0}
                            size="lg"
                            variant="orange"
                            onClick={() => {
                                if (onBackClick) {
                                    onBackClick();
                                } else if (backUrl) {
                                    router.push(`/${language}${backUrl}`);
                                }
                            }}
                        />

                        {actionComponent && <Box>{actionComponent}</Box>}
                    </Flex>
                    {isReady ? (
                        <Box
                            alignItems="center"
                            display="flex"
                            justifyContent="space-between"
                            mt={4}>
                            <Heading isTruncated size="lg">
                                {title}
                            </Heading>
                            {multiUser && (showUserPicker || router.asPath.endsWith('/home')) && (
                                <>
                                    <FontAwesomeIcon
                                        icon={faCircleUser}
                                        size="2xl"
                                        onClick={onOpen}
                                    />
                                    <SelectUserModal
                                        currentUser={currentUser}
                                        isOpen={isOpen}
                                        setCurrentUserId={setCurrentUserId}
                                        users={users}
                                        onClose={onClose}
                                    />
                                </>
                            )}
                        </Box>
                    ) : (
                        <HStack mt={4} spacing={2}>
                            <Skeleton height="31.91px" width="88.78px" />
                            <Skeleton height="31.91px" width="143.64px" />
                        </HStack>
                    )}
                </Container>
            </Box>
        </Box>
    );
};

export default Topbar;
